import { getPath } from './getPath';

/**
 * Pobiera wartość kolumny
 *
 * @export
 * @param {*} object
 * @param {*} column
 * @param {{ fieldWithPath: string; fieldWithTransformer: string }} [options]
 * @returns {string}
 */
export function getColumnValue(
  object: any,
  column: any,
  options?: { fieldWithPath: string; fieldWithTransformer: string }
): string {
  const fieldWithPath = options?.fieldWithPath || 'name';
  const fieldWithTransformer = options?.fieldWithTransformer || 'nameTransformer';
  const value = getPath(object, column[fieldWithPath]);
  if (column[fieldWithTransformer]) {
    if (typeof column[fieldWithTransformer] === 'string') {
      return new Function('value', 'rowItem', column[fieldWithTransformer])(value, object);
    }
    return column.nameTransformer(value, object);
  }
  return value;
}
